app.factory('resourceBucketsConfigurationService', ['propertyService', 'configurationService', function (propertyService, configurationService) {
    var service = {};
    
    service.getControllingModel = function () {
        return configurationService.getControllingModel();        
    }
    return service;
}]);